import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import RegisterUser from "./RegisterNewUser";
import ChangeCustId from "./ChangeCustId";

class Admin extends Component {
  constructor(props) {
    super(props);

  }

  render(){
    return (
      <div>
        <div className="flex-container flex-column">
          <div className="centered-container">
            <RegisterUser/>
          </div>
        </div>
        <br/><br/><br/>
      </div>
    );
  }

}

const mapStateToProps = function(state) {
  return {
    user: state.oidc.user
  }
};

//export default NavMenu;
export default withRouter(connect(mapStateToProps)(Admin));